module.exports = __webpack_public_path__ + "img/Image48.cd569741.png";